import { render, staticRenderFns } from "./MaterialLog.vue?vue&type=template&id=6dcf252b"
import script from "./MaterialLog.vue?vue&type=script&lang=js"
export * from "./MaterialLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports